// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"9202e394","459":"849c02a0","760":"e1eb41b1","774":"a5b24a21","966":"5c436724"}[chunkId] + ".chunk.js";
};